import { type ReactElement, createContext, useContext, useEffect } from 'react';
import { GqlStripeSubscriptionStatus, useStripeSubscriptionsLazyQuery } from '../../graphql/react-operations';
import { isNil } from 'lodash-es';

const SubscriptionContext = createContext(false);

interface Props {
  companyId?: string;
  children: ReactElement | ReactElement[];
}

const SubscriptionStatusProvider = ({ children, companyId }: Props) => {
  const [getStripeSubscriptions, { data }] = useStripeSubscriptionsLazyQuery();

  useEffect(() => {
    if (companyId) {
      void getStripeSubscriptions({
        variables: {
          companyId: companyId,
        },
      });
    }
  }, [companyId, getStripeSubscriptions]);

  const hasActiveSub = () => {
    if (
      !isNil(data) &&
      data.stripeSubscriptions.length > 0 &&
      // @ts-expect-error TS2532
      (data.stripeSubscriptions[0].status === 'active' ||
        // @ts-expect-error TS2532
        data.stripeSubscriptions[0].status === GqlStripeSubscriptionStatus.Trialing)
    ) {
      return true;
    }
    return false;
  };

  const hasActiveSubValue = hasActiveSub();

  return <SubscriptionContext.Provider value={hasActiveSubValue}>{children}</SubscriptionContext.Provider>;
};

const useSubscriptionStatus = () => {
  const context = useContext(SubscriptionContext);
  if (context === undefined) {
    throw new Error('useSubscription must be used within a SubscriptionProvider');
  }
  return context;
};

export { SubscriptionStatusProvider, useSubscriptionStatus };
